import template from "./bSpinner.html";

export function bSpinnerDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bSpinnerController,
    controllerAs: 'bSpinner',
    bindToController: true,
    scope: {
      noBackground: "=?"
    }
  };

  return directive;
}

class bSpinnerController {
  constructor() {
    'ngInject';
  }
}